/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Choose_DescInputs */

const en_site_choose_desc = /** @type {(inputs: Site_Choose_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste the address of a site you admire or compete with. Bystep dissects it, then interviews you about your own version.`)
};

const id_site_choose_desc = /** @type {(inputs: Site_Choose_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempel alamat situs yang kamu kagumi atau pesaingmu. Bystep membedahnya, lalu mewawancaraimu untuk versi milikmu sendiri.`)
};

/**
* | output |
* | --- |
* | "Paste the address of a site you admire or compete with. Bystep dissects it, then interviews you about your own version." |
*
* @param {Site_Choose_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_choose_desc = /** @type {((inputs?: Site_Choose_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Choose_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_choose_desc(inputs)
	return en_site_choose_desc(inputs)
});